import { apiService } from "../services/api.service";

export const odoslanieDodavkyController = {
    getOdoslanieDodavky,
    getFirstDodavkaByExpediciaId,
    getBalikyByDodavkaId
};

function getOdoslanieDodavky() {
    return apiService.fetchApiRequest("api/OdoslanieDodavky/GetOdoslanieDodavky");
}

function getFirstDodavkaByExpediciaId(expediciaId) {
    return apiService.fetchApiRequest("api/OdoslanieDodavky/GetFirstDodavkaByExpediciaId?expediciaId=" + expediciaId);
}

function getBalikyByDodavkaId(dodavkaId) {
    return apiService.fetchApiRequest("api/OdoslanieDodavky/GetBalikyByDodavkaId?dodavkaId=" + dodavkaId);
}



// WEBPACK FOOTER //
// ./src/controllers/odoslaniedodavky.controller.js